import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const prodFirebaseConfig = {
  apiKey: "AIzaSyDHV1R4ajUwpJJ7QZWWJ3hlMhqaOpilXEU",
  authDomain: "local-helperrr.firebaseapp.com",
  projectId: "local-helperrr",
  storageBucket: "local-helperrr.firebasestorage.app",
  messagingSenderId: "961398993293",
  appId: "1:961398993293:web:7b63f266e9b68921b64dc4",
};

const devFirebaseConfig = {
  authDomain: "local-helper-dev.firebaseapp.com",
  apiKey: "AIzaSyBvlJDvZChBxk6f0t8Yn5nZ1uRK_hvCog4",
  appId: "1:159745198832:android:5344e5a108e7dda047d035",
  messagingSenderId: "159745198832",
  projectId: "local-helper-dev",
  storageBucket: "local-helper-dev.firebasestorage.app",
};

const firebaseEnvironment = process.env.REACT_APP_FIREBASE_ENV || "dev";

const firebaseConfig = firebaseEnvironment === "prod"
  ? prodFirebaseConfig
  : devFirebaseConfig;

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export { firebaseEnvironment };
export default app;